<!-- 
CustTagModal.vue
功能：客戶標籤視窗
作者：i9400538 陳博承
完成：2021-04-09
-->
<template>
  <div id="service-modal" class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog w-800">
      <div class="modal-content">
        <div class="modal-header">
          <a @click="$emit('close')" class="close">
            <i class="icon-close"></i>
          </a>
          <div class="float-left w-55 pr-3">
            <h3 class="mb-line-title-top text-green mt-0 mb-0">{{data.tag_show_name ? data.tag_show_name : data.tag_name}}</h3>
            <div>
              <img :src="picno_url" width="120" alt="icon" />
            </div>
          </div>
          <div class="float-left w-100 pr-3">
            <div class="mb-line-top">
              <span class="font-weight-bold mr-2 text-green underline">
                <img :src="`${BaseUrl}assets/tagicon/defination.png`" width="15" alt="defination" />定義
              </span>
              <br />
              <span v-html="data.tag_agdef" class="tag-string"></span>
            </div>
            <div class="mb-line">
              <span class="font-weight-bold mr-2"></span>
              <span></span>
            </div>
            <div class="mb-line">
              <span class="font-weight-bold mr-2 text-green underline">
                <img
                  :src="`${BaseUrl}assets/tagicon/application-technique.png`"
                  width="15"
                  alt="technique"
                />應用技巧
              </span>
              <br />
              <span v-html="data.tag_agusage" class="tag-string"></span>
            </div>
            <div class="mb-line">
              <span class="font-weight-bold mr-2"></span>
              <span></span>
            </div>
            <div
              class="mb-line"
              v-if="data.doc_realname_1 || data.doc_realname_2 || data.doc_realname_3 || data.doc_weblink_1 || data.doc_weblink_2 || data.doc_weblink_3"
            >
              <span class="font-weight-bold mr-2 text-green underline">
                <img :src="`${BaseUrl}assets/tagicon/document-icon.png`" width="15" alt="document" />參考資料
              </span>
              <br />
              <div class="display-grid">
                <!--附件1-->
                <span v-if="data.doc_showname_1">
                  <!--檔案-->
                  <span
                    v-if="data.doc_realname_1"
                    class="file-text"
                    @click="downloadFile(data.tag_id,data.doc_realname_1)"
                  >{{data.doc_showname_1}}</span>
                  <!--連結-->
                  <span v-else-if="data.doc_weblink_1">
                    <a
                      :href="data.doc_weblink_1"
                      target="_blank"
                      class="file-text"
                    >{{data.doc_showname_1}}</a>
                  </span>
                </span>
                <!--附件2-->
                <span v-if="data.doc_showname_2">
                  <!--檔案-->
                  <span
                    v-if="data.doc_realname_2"
                    class="file-text"
                    @click="downloadFile(data.tag_id,data.doc_realname_2)"
                  >{{data.doc_showname_2}}</span>
                  <!--連結-->
                  <span v-else-if="data.doc_weblink_2">
                    <a
                      :href="data.doc_weblink_2"
                      target="_blank"
                      class="file-text"
                    >{{data.doc_showname_2}}</a>
                  </span>
                </span>
                <!--附件3-->
                <span v-if="data.doc_showname_3">
                  <!--檔案-->
                  <span
                    v-if="data.doc_realname_3"
                    class="file-text"
                    @click="downloadFile(data.tag_id,data.doc_realname_3)"
                  >{{data.doc_showname_3}}</span>
                  <!--連結-->
                  <span v-else-if="data.doc_weblink_3">
                    <a
                      :href="data.doc_weblink_3"
                      target="_blank"
                      class="file-text"
                    >{{data.doc_showname_3}}</a>
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <h4>同樣標籤的客戶</h4>
          <div
            class="button-grid p-0 four-items card-text-format"
            :class="{'section-loading': isLoading}"
          >
            <a
              class="btn btn-border-green"
              v-for="(item, i) in cust"
              :key="`same-tag-item-${i}`"
              @click="clickItem(item)"
            >
              <span v-text="`${item.show_name}`"></span>
            </a>
          </div>
          <h4 v-if="isShow" class="text-center">無</h4>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { commonMixin } from "@/mixins/common";
//component
import { saveAs } from "file-saver";
//service
import { getSameTagCust, addCustTagLog, downloadTagFile } from "@/service";

export default {
  name: "CustTagModal",
  mixins: [commonMixin],
  props: {
    open: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      icon: "",
      isLoading: false,
      cust: [],
      isShow: false,
      picno_url: "",
      tagFile: null,
    };
  },
  computed: {
    ...mapGetters(["BaseUrl"]),
    isBox() {
      // 判斷是否為 box
      return this.$store.state.userInfo.userType === "box";
    }
  },
  watch: {
    open: function(val) {
      if (val) {
        this.init();
        this.isShow = false;
        this.getPicNo();
      }
    }
  },
  methods: {
    ...mapActions(["updateCustID"]),
    clickItem(item) {
      // 客戶標籤點擊留存log紀錄
      const tagLogData = {
        agnt_id: this.$store.state.userInfo.id,
        agnt_name: this.$store.state.userInfo.name,
        agnt_dvno: this.$store.state.userInfo.divNo,
        agnt_dvname: this.$store.state.userInfo.divFullName,
        cust_id: item.id,
        cust_name: item.name,
        tag_id: this.data.tag_id,
        tag_name: this.data.tag_name,
        cust_behavior: "2"
      };
      // 新增客戶標籤點擊留存log紀錄
      addCustTagLog(this.$store.state.userInfo.id, tagLogData);
      this.$emit("selectCust", { csid: item.id, csname: item.name });
    },
    // 資料初始化
    init() {
      this.isLoading = true;
      getSameTagCust(
        this.$store.state.userInfo.id,
        this.data.tag_id,
        this.data.party_id
      ).then(result => {
        this.isLoading = false;
        if (
          result.header &&
          result.header.status === "200" &&
          result.body.result
        ) {
          this.cust = result.body.result.map(item => {
            let showText =
              item.age == undefined || item.age == ""
                ? "(— —歲)"
                : "(" + item.age.toString() + "歲)"; //客戶年齡;
            return {
              id: item.party_id,
              name: item.name,
              show_name: item.name + showText
            };
          });
          this.registerHanlink(); // for hard word
          this.isShow = (this.cust && this.cust.length == 0) || !this.cust;
        } else {
          this.$toast.info({ title: "取得同樣標籤的客戶失敗" });
        }
      });
    },
    //下載附件
    async downloadFile(tag_id, filename) {
      await this.doDownloadTagFile(tag_id, filename)
      const result = this.tagFile
      if (this.isBox) {
        const buffer = await this.converBlobToBuffer(result)
        this.boxSendBase64PdfData(buffer)
      }else{
        let vm = this;
        if (result.type === "application/json") {
          //  json 為檔案下載失敗
          //  把回傳的 blob 轉為 文字檔後再用 json parse
          let reader = new FileReader();
          reader.onload = function() {
            let unicodeJsonA = JSON.parse(reader.result);
            if (unicodeJsonA.header.message) {
              vm.setToastMsg(unicodeJsonA.header.message);
            } else {
              vm.setToastMsg("伺服器連線異常");
            }
          };
          reader.readAsText(result);
        } else {
          //  成功取得檔案  進行下載
          saveAs(result, filename);
        }
      }
    },
    async doDownloadTagFile(tag_id, filename){
      await downloadTagFile(this.$store.state.userInfo.id, tag_id, filename).then(
          result => {
            this.tagFile = result
          }
        );
    },
    async converBlobToBuffer(blob){
      const arrayBuffer  = await blob.arrayBuffer();
      return arrayBuffer
    },
    //取得頭像圖檔
    getPicNo() {
      let tagID = this.data.tag_id || "";
      let picNo = this.data.picno || "";
      if (tagID && picNo) {
        let filePath = tagID + "/" + picNo;
        if (
          window.location.href.indexOf("localhost") !== -1 ||
          window.location.href.indexOf("tmycrm") !== -1
        ) {
          this.picno_url =
            "https://tmycrm.cathaylife.com.tw/CRMDocs/tag/" + filePath;
        } else if (window.location.href.indexOf("smycrm") !== -1) {
          this.picno_url =
            "https://smycrm.cathaylife.com.tw/CRMDocs/tag/" + filePath;
        } else {
          this.picno_url =
            "https://mycrm.cathaylife.com.tw/CRMDocs/tag/" + filePath;
        }
      } else {
        this.picno_url = "";
      }
    }
  }
};
</script>

<style>
.underline {
  text-decoration: underline;
}
.card-text-format {
  word-wrap: break-word;
  word-break: break-all;
}
.w-55 {
  width: 55%;
  text-align: center;
}
.w-800 {
  width: 800px;
}
.mb-line-title-top {
  margin-top: 1.45rem !important;
  margin-bottom: 0.625rem !important;
}
.mb-line-top {
  margin-top: 1.58rem !important;
  margin-bottom: 0.625rem !important;
}
.header-hight {
  height: 250px;
}
.text-center {
  text-align: center;
}
.tag-string {
  white-space: pre-wrap;
}
.display-grid {
  display: grid;
}
.file-text {
  cursor: pointer;
  font-weight: 600;
  color: orange;
  text-decoration: underline;
}
</style>
